import React, { memo } from 'react';
export function EvidenceSection() {
  const metrics = [{
    label: 'Chiarezza mentale',
    progress: 85
  }, {
    label: 'Energia cerebrale',
    progress: 78
  }, {
    label: 'Velocità di ragionamento',
    progress: 72
  }];
  return <section id="evidenze" className="w-full bg-white py-20 px-4 sm:px-6 lg:px-8" data-id="element-36">
      <div className="max-w-4xl mx-auto" data-id="element-37">
        <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-8 text-center" data-id="element-38">
          Cosa dicono i dati (in parole semplici)
        </h2>
        <p className="text-lg sm:text-xl text-gray-700 mb-12 max-w-3xl mx-auto text-center" data-id="element-39">
          Approcci che combinano allenamento cognitivo, alimentazione
          mediterranea e gestione dello stress mostrano miglioramenti misurabili
          in memoria/attenzione negli adulti over 55. Le evidenze europee
          sottolineano che abitudini costanti contano più dell'intensità.
        </p>
        <div className="bg-gray-50 p-8 rounded-lg mb-8" data-id="element-40">
          <h3 className="text-2xl font-bold text-gray-900 mb-6 text-center" data-id="element-41">
            Risultati tipici dopo 2–4 settimane:
          </h3>
          <div className="space-y-6" data-id="element-42">
            {metrics.map((metric, index) => <div key={index} data-id="element-43">
                <div className="flex justify-between mb-2" data-id="element-44">
                  <span className="text-lg font-medium text-gray-900" data-id="element-45">
                    {metric.label}
                  </span>
                  <span className="text-lg font-bold text-green-600" data-id="element-46">↑</span>
                </div>
                <div className="w-full bg-gray-200 rounded-full h-4" data-id="element-47">
                  <div className="bg-green-600 h-4 rounded-full transition-all duration-1000" style={{
                width: `${metric.progress}%`
              }} data-id="element-48" />
                </div>
              </div>)}
          </div>
          <p className="text-base text-gray-600 mt-6 italic text-center" data-id="element-49">
            I risultati variano: il percorso non sostituisce consigli medici.
          </p>
        </div>
        <div className="bg-blue-50 border-l-4 border-blue-500 p-6 rounded-r-lg" data-id="element-50">
          <p className="text-base sm:text-lg text-gray-700" data-id="element-51">
            <strong data-id="element-52">Riferimenti:</strong> organismi europei di riferimento (es.
            Alzheimer Europe) e letteratura internazionale di benessere
            cognitivo.
          </p>
        </div>
      </div>
    </section>;
}